import { render, staticRenderFns } from "./BannerFrame.vue?vue&type=template&id=22daeb68"
import script from "./BannerFrame.vue?vue&type=script&lang=js"
export * from "./BannerFrame.vue?vue&type=script&lang=js"
import style0 from "./BannerFrame.vue?vue&type=style&index=0&id=22daeb68&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports